import { Archive, CheckCircle2, Clock } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { ProductStatus } from '@shared/contracts/enums'
import type { StatusTone } from '@shared/design-system/ui'

export type ProductStatusPresentation = {
  tone: StatusTone
  label: string
  icon: LucideIcon
}

const presentationByStatus: Record<ProductStatus, ProductStatusPresentation> = {
  DRAFT: { tone: 'awaiting', label: 'Rascunho', icon: Clock },
  ACTIVE: { tone: 'success', label: 'Publicado', icon: CheckCircle2 },
  ARCHIVED: { tone: 'closed', label: 'Arquivado', icon: Archive },
}

export function getProductStatusPresentation(status: ProductStatus): ProductStatusPresentation {
  return presentationByStatus[status]
}
